import { Check } from "lucide-react";
import { Reveal, Kicker } from "@/components/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";
import { IMG } from "@/constants/assets";

export function Sculpture() {
  const { t } = useLanguage();
  const points = [t("scu_p1"), t("scu_p2"), t("scu_p3")];

  return (
    <section id="sculpture" data-testid="sculpture-section" className="relative py-28 md:py-40 bg-[#0B0A08] overflow-hidden">
      <span className="pointer-events-none select-none absolute -top-10 right-0 font-serif-d italic text-[16rem] leading-none text-[#C5A059]/5 hidden lg:block">Art</span>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal y={60} className="relative">
          <div className="img-frame aspect-[3/4] max-w-md">
            <img src={IMG.sculptor} alt="Maître sculpteur" className="w-full h-full object-cover" loading="lazy" />
          </div>
          <div className="absolute -bottom-8 -right-2 md:right-6 w-44 md:w-56 img-frame border border-[#C5A059]/40 bg-[#0B0A08] p-2">
            <img src={IMG.carving} alt="Détail de sculpture" className="w-full aspect-square object-cover" loading="lazy" />
          </div>
        </Reveal>

        <div>
          <Reveal><Kicker>{t("scu_kicker")}</Kicker></Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif-d text-4xl md:text-5xl mt-6 text-[#F7F4EE] leading-tight">{t("scu_title")}</h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 text-sm md:text-base text-[#B8B0A2] leading-relaxed">{t("scu_body")}</p>
          </Reveal>
          <div className="mt-8 space-y-4">
            {points.map((p, i) => (
              <Reveal key={i} delay={0.25 + i * 0.1}>
                <div className="flex items-center gap-4">
                  <span className="w-7 h-7 shrink-0 border border-[#D4AF37] flex items-center justify-center text-[#D4AF37]">
                    <Check size={13} />
                  </span>
                  <span className="text-sm text-[#F7F4EE] tracking-wide">{p}</span>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.55}>
            <p className="mt-10 font-serif-d italic text-lg text-[#C5A059] border-l-2 border-[#C5A059]/40 pl-5">
              « Le bois se tait. C'est le ciseau qui le fait parler. »
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
